import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const ThirdPartyForm_Organization_Create_Mutation = graphql(`
  mutation ThirdPartyForm_Organization_Create(
    $organization: OrganizationInput!
    $versionData: VersionDataInput
  ) {
    createOrganization(doc: $organization, versionData: $versionData) {
      _id
    }
  }
`);

export type OrganizationInput = VariablesOf<
  typeof ThirdPartyForm_Organization_Create_Mutation
>['organization'];

export type ThirdPartyForm_Organization_Create_Result = ResultOf<
  typeof ThirdPartyForm_Organization_Create_Mutation
>;

export const useCreateOrganizationMutation = () =>
  useGraphQLMutation(ThirdPartyForm_Organization_Create_Mutation);
